import { Info } from "lucide-react";

export const ViewingTips = () => (
  <div className="glass-card p-6">
    <div className="flex items-center gap-2 mb-4">
      <Info className="w-5 h-5 text-cosmic-blue" strokeWidth={1.5} />
      <h3 className="section-title">Viewing Tips</h3>
    </div>
    <div className="space-y-3 text-sm text-slate-400">
      <p>
        <strong className="text-white">For rocket launches:</strong> Less moonlight (new moon or crescent phases) 
        provides darker skies, making rocket exhaust plumes more visible.
      </p>
      <p>
        <strong className="text-white">For stargazing:</strong> Plan your observations around the new moon 
        when the sky is darkest.
      </p>
      <p>
        <strong className="text-white">Full Moon viewing:</strong> Great time to observe lunar features with 
        binoculars or telescopes!
      </p>
    </div>
  </div>
);
